<template>
  <div v-loading="dataLoading" class="account-supplement">
    <rhcn-drawer title="message.user.supplement" :description="$t('message.user.supplementTips')" :showClose="false">
      <template slot="headerRight">
        <span class="back2mercahnt" @click="onBack()">
          {{ $t('message.user.backMerchant') }}<i class="iconfont icon-fanhui margin-left-4"></i></span>
      </template>
      <div class="drawer-form">
        <div v-if="isFailed && errorMessage" class="fail-reason-box">
          <p>{{ errorMessage }}</p>
        </div>
        <!-- 业务描述 -->
        <validation-component ref="businessFormRef" :validation-condition="bussinessCondition">
        </validation-component>
        <!-- 附件上传 -->
        <p class="supplement-info-title margin-bottom-5">{{ $t('message.user.updatingFiles') }}</p>
        <div class="supplement-info-box">
          <!-- 企业证明 -->
          <div class="margin-bottom-15">
            <div class="supplement-info-title margin-bottom-10">
              <span>{{ $t('message.user.businessCertificate') }}</span>
              <p>
                <span class="link"
                  @click="onViewExample('/static/payout/img-company-certificate.png')">{{ $t('message.common.viewExamples') }}</span>
                <span v-if="businessCertificateList.length < 5" class="btn-add margin-left-20"
                  @click="handleAddBusinessCertificate">{{ $t('message.user.add') }}</span>
              </p>
            </div>
            <div class="file-list-box">
              <div class="bussiness-certificate-item" v-for="(item, index) in businessCertificateList" :key="index">
                <RhcnUpload
                  :title="index === 0 ? $t('message.user.businessCertificateFile') : $t('message.user.businessOtherFile')"
                  :fileList="item.fileList" :accept="'image/png,image/jpeg,image/jpg,image/bmp'"
                  :on-change="onBusinessItemChange(index)" :on-remove="onBusinessItemRemove(index)">
                  <template #right>
                    <span v-if="index > 0" class="btn-delete el-icon-circle-close"
                      @click="handleDeleteBusinessCertificate(index, $event)"></span>
                  </template>
                </RhcnUpload>
              </div>
            </div>
          </div>
          <!-- 董事 -->
          <div class="margin-bottom-15 shareholder-info">
            <div>
              <div v-for="(item, index) in shareholderList" :key="index" class="shareholder-item">
                <div class="supplement-info-title margin-bottom-10">
                  <span>{{ $t('message.user.shareholder') }}<span v-if="index > 0" class="btn-delete el-icon-circle-close"
                      @click="handleDeleteShareholder(index)"></span></span>
                  <p v-if="index === 0">
                    <span class="link"
                      @click="onViewExample('/static/payout/img-idcard.png')">{{ $t('message.common.viewExamples') }}</span>
                    <span v-if="shareholderList.length < 5" class="btn-add margin-left-20"
                      @click="handleAddShareholder">{{ $t('message.user.add') }}</span>
                  </p>
                </div>
                <div class="file-list-box">
                  <RhcnUpload :title="$t('message.user.certificateFileFront')" :fileList="item.frontList"
                    :accept="'image/png,image/jpeg,image/jpg,image/bmp'"
                    :on-change="onShareholderItemChange(index, 'front')"
                    :on-remove="onShareholderItemRemove(index, 'front')">
                  </RhcnUpload>
                  <p class="margin-right-10"></p>
                  <RhcnUpload :title="$t('message.user.certificateFileReverse')" :fileList="item.reverseList"
                    :accept="'image/png,image/jpeg,image/jpg,image/bmp'"
                    :on-change="onShareholderItemChange(index, 'reverse')"
                    :on-remove="onShareholderItemRemove(index, 'reverse')">
                  </RhcnUpload>
                </div>
              </div>
            </div>
          </div>
          <!-- 受益人 -->
          <div class="margin-bottom-20 beneficiary-info">
            <div>
              <div v-for="(item, index) in beneficiaryList" :key="index" class="beneficiary-item">
                <div class="supplement-info-title margin-bottom-10">
                  <span>{{ $t('message.user.beneficiary') }}<span v-if="index > 0" class="btn-delete el-icon-circle-close"
                      @click="handleDeleteBeneficiary(index)"></span></span>
                  <p v-if="index === 0">
                    <span class="link"
                      @click="onViewExample('/static/payout/img-idcard.png')">{{ $t('message.common.viewExamples') }}</span>
                    <span v-if="beneficiaryList.length < 5" class="btn-add margin-left-20"
                      @click="handleAddBeneficiary">{{ $t('message.user.add') }}</span>
                  </p>
                </div>
                <div class="file-list-box">
                  <RhcnUpload :title="$t('message.user.certificateFileFront')" :fileList="item.frontList"
                    :accept="'image/png,image/jpeg,image/jpg,image/bmp'"
                    :on-change="onBeneficiaryItemChange(index, 'front')"
                    :on-remove="onBeneficiaryItemRemove(index, 'front')">
                  </RhcnUpload>
                  <p class="margin-right-10"></p>
                  <RhcnUpload :title="$t('message.user.certificateFileReverse')" :fileList="item.reverseList"
                    :accept="'image/png,image/jpeg,image/jpg,image/bmp'"
                    :on-change="onBeneficiaryItemChange(index, 'reverse')"
                    :on-remove="onBeneficiaryItemRemove(index, 'reverse')">
                  </RhcnUpload>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-form v-if="!isFailed" class="margin-top-20" ref="basicFormRef" :model="basicInfo" :rules="basicRules"
          :label-position="'top'">
          <el-form-item :label="$t('message.user.phone')" prop="phoneNumber">
            <el-input v-model="basicInfo.phoneNumber" maxlength="15"
              :placeholder="$t('message.validator.input', { input: $t('message.user.phone') })" @input="onPhoneInput">
              <el-select v-model="basicInfo.areaCode" slot="prepend" filterable>
                <el-option v-for="(item, index) in PHONE_AREAS" :key="index" :label="item.label"
                  :value="item.value">{{ item.description }}</el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <div class="captcha-box">
              <el-input class="captcha-input" v-model="basicInfo.captcha"
                :placeholder="$t('message.validator.input', { input: $t('message.user.captcha') })"></el-input>
              <div>
                <el-button v-loading="requestingCode" class="btn-captcha" @click="sendCaptcha">{{ captchaLeftTime > 0 ?
                  `${captchaLeftTime}s` : $t('message.user.sendCaptcha')}}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="margin-top-34 form-bottom-box">
          <p class="btn-temporary-save" @click="onTemporarySave">{{ $t('message.user.saveTemporary') }}</p>
          <el-button style="width:100%;" type="primary" @click="onSubmit">{{ $t('message.common.submit') }}</el-button>
        </div>
        <el-dialog width="30%" :visible.sync="showExample" :modal-append-to-body="false">
          <img width="100%" :src="exampleImgUrl" alt="" />
        </el-dialog>
      </div>
      <custom-message ref="saveModal" :cancelButtonText="$t('message.user.stayPage')"
        :confirmButtonText="$t('message.user.backMerchant')"></custom-message>
    </rhcn-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { queryRegisterCountry } from '@/api/common/index';
import { PHONE_AREAS } from '@/api/common/phone-area.js';
import {
  getUserInformation, updateMerchantInformation, getPhoneCaptcha,
  postCacheImproveInformation, queryCacheImproveInformation,
  addMerchantInformation,
} from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowWarningMessage, ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import { validateFns, REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { initSelectedData } from '@/utils/tools/constant';
import { getFileNameFromUrl } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import RhcnUpload from '@/views/account/information/supplement/upload-v2/index.vue';
import { uploadMaterialUseTemplate } from '@/views/transfer/api/contact';

export default {
  components: {
    RhcnDrawer,
    ValidationComponent,
    RhcnUpload,
    CustomMessage,
  },
  data() {
    return {
      dataLoading: false,
      bussinessCondition: [{
        key: 'merchantName',
        name: 'message.user.supplementMerchantName',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: this.$t('message.validator.input', { input: this.$t('message.user.merchantName').toLowerCase() }),
      }, {
        key: 'registration',
        name: 'message.user.businessRegistration',
        type: 'select',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: this.$t('message.validator.select', { select: '' }),
      }],
      basicInfo: {
        phoneNumber: '',
        captcha: '',
        areaCode: '+44',
      },
      basicRules: {
        phoneNumber: [
          { validator: validateFns([REQUIRED]) },
        ],
        captcha: [
          { validator: validateFns([REQUIRED]) },
        ],
      },
      businessCertificateList: [{}],
      shareholderList: [{}],
      beneficiaryList: [{}],
      showExample: false,
      exampleImgUrl: '',
      PHONE_AREAS,
      requestingCode: false,
      captchaLeftTime: 0,
      isFailed: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    isFastPayout() {
      return this.$route.query.isFastPayout;
    },
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      this.dataLoading = true;
      try {
        const res = await AccountInfo.getAccountInfo();
        console.log('res', res);
        if (res && res.auditStatus && res.auditStatus !== 'fail' && res.businessTypes.includes('PAYOUT')) {
          // console.log('res1111111111');
          this.$router.replace({ path: '/index' });
          return;
        }
        this.isFailed = res.auditStatus === 'fail' || res.rejectReason;
        this.errorMessage = res.auditComments || res.rejectReason;

        let info;
        try {
          info = await queryCacheImproveInformation();
        } catch (err) {
          //
        }
        if (!info) {
          const params = {
            isFastPayout: this.isFastPayout || null,
          };
          console.log(params, 'params');
          const infoRes = await getUserInformation(params);
          info = JSON.parse(infoRes);
        }

        if (info.phoneNumber) {
          this.basicInfo.phoneNumber = info.phoneNumber;
        }
        if (info.areaCode) {
          this.basicInfo.areaCode = info.areaCode;
        }

        const countryRes = await queryRegisterCountry();
        const countryList = countryRes.map(item => ({
          value: `${item.countryCodeIso2}`,
          label: `${item.countryNameCn}-${item.countryName}`,
        }));

        this.$refs.businessFormRef.assignmentFormValue({ ...info });
        this.$refs.businessFormRef.setValidationSelectOptions('registration', countryList);

        this.businessCertificateList = [{}];
        if (info.companyCertFiles && info.companyCertFiles.length > 0) {
          this.businessCertificateList = info.companyCertFiles.map(item => ({
            fileList: item && item.trim() ? [{
              url: item,
              name: decodeURIComponent(getFileNameFromUrl(item)),
            }] : [],
          }));
        }

        this.shareholderList = [{}];
        if (info.directorCertFiles && info.directorCertFiles.length > 0) {
          this.shareholderList = info.directorCertFiles.map(item => ({
            frontList: item.front && item.front.trim() ? [{
              url: item.front,
              name: decodeURIComponent(getFileNameFromUrl(item.front)),
            }] : [],
            reverseList: item.reverse && item.reverse.trim() ? [{
              url: item.reverse,
              name: decodeURIComponent(getFileNameFromUrl(item.reverse)),
            }] : [],
          }));
        }

        this.beneficiaryList = [{}];
        if (info.beneficiaryCertFiles && info.beneficiaryCertFiles.length > 0) {
          this.beneficiaryList = info.beneficiaryCertFiles.map(item => ({
            frontList: item.front && item.front.trim() ? [{
              url: item.front,
              name: decodeURIComponent(getFileNameFromUrl(item.front)),
            }] : [],
            reverseList: item.reverse && item.reverse.trim() ? [{
              url: item.reverse,
              name: decodeURIComponent(getFileNameFromUrl(item.reverse)),
            }] : [],
          }));
        }
      } catch (err) {
        //
        console.log(err);
      }
      this.dataLoading = false;
    },
    validateCertificate() {
      for (let i = 0; i < this.businessCertificateList.length; i++) {
        const item = this.businessCertificateList[i];
        if (!item.fileList || item.fileList.length === 0) {
          ShowWarningMessage(this.$t('message.user.businessCertificationTips'));
          return false;
        }
      }
      return true;
    },
    validateShareholder() {
      for (let i = 0; i < this.shareholderList.length; i++) {
        const item = this.shareholderList[i];
        if (!item.frontList || !item.reverseList || item.frontList.length === 0 || item.reverseList.length === 0) {
          ShowWarningMessage(this.$t('message.user.shareholderTips'));
          return false;
        }
      }
      return true;
    },
    validateBeneficiary() {
      for (let i = 0; i < this.beneficiaryList.length; i++) {
        const item = this.beneficiaryList[i];
        if (!item.frontList || !item.reverseList || item.frontList.length === 0 || item.reverseList.length === 0) {
          ShowWarningMessage(this.$t('message.user.beneficiaryTips'));
          return false;
        }
      }
      return true;
    },
    getFormData() {
      const data = {
        businessType: '0',
        ...this.$refs.businessFormRef.getFormJson(),
        companyCertFiles: this.businessCertificateList.map(item => item.fileList && item.fileList.length > 0 ? item.fileList[0].url : ''),
        directorCertFiles: this.shareholderList.map(item => ({
          front: item.frontList && item.frontList.length > 0 ? item.frontList[0].url : '',
          reverse: item.reverseList && item.reverseList.length > 0 ? item.reverseList[0].url : '',
        })),
        beneficiaryCertFiles: this.beneficiaryList.map(item => ({
          front: item.frontList && item.frontList.length > 0 ? item.frontList[0].url : '',
          reverse: item.reverseList && item.reverseList.length > 0 ? item.reverseList[0].url : '',
        })),
      };

      if (!this.isFailed) {
        data.phoneNumber = this.basicInfo.phoneNumber;
        data.areaCode = this.basicInfo.areaCode;
      }

      return data;
    },
    async onTemporarySave() {
      console.log('onTemporarySave');
      this.dataLoading = true;
      try {
        const data = this.getFormData();
        await postCacheImproveInformation(data);
        this.$refs.saveModal.openDefaultModal({
          titleHtml: this.$t('message.common.prompt'),
          contentHtml: this.$t('message.user.saveTemporaryTips'),
          onOkClick: (action, instance, done) => {
            done();
            console.log(this.app.userLogin.isAggregateMerchant, 'this.app.userLogin.isAggregateMerchant');
            if (this.app.userLogin.isAggregateMerchant) {
              this.$router.replace({
                path: '/index/aggregate/payout',
              });
            } else {
              this.$router.replace({
                path: '/index',
              });
            }
          },
        });
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    async onSubmit() {
      // console.log('onSubmit');
      // const demo = true;
      // if (demo) {
      //   return;
      // }
      this.dataLoading = true;
      let isError = false;
      try {
        const businessValid = await this.$refs.businessFormRef.validateAsync();
        if (this.$refs.basicFormRef) {
          await this.$refs.basicFormRef.validate();
        }
        if (!businessValid) {
          isError = true;
        }
        if (!isError && this.validateCertificate() && this.validateShareholder() && this.validateBeneficiary()) { // 表单验证无误，则开始验证附件上传信息
          // 数据校验无误，则提交数据
          const data = this.getFormData();
          data.isFastPayout = !!this.app.userLogin.isAggregateMerchant;
          let SubMethod = updateMerchantInformation;
          if (!this.isFailed) {
            data.captcha = this.basicInfo.captcha;
            SubMethod = addMerchantInformation;
          }
          await SubMethod(data);
          if (this.app.userLogin.isAggregateMerchant) {
            this.$router.replace({
              path: '/account/supplement/done',
              query: {
                isFast: true,
              },
            });
          } else {
            this.$router.replace({
              path: '/account/supplement/done',
            });
          }
        }
      } catch (err) {
        isError = true;
      }
      if (isError) {
        this.$nextTick(() => {
          const errorDom = document.querySelector('.is-error');
          if (errorDom) {
            errorDom.scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            });
          }
        });
      }
      this.dataLoading = false;
    },
    // 企业证明信息
    handleAddBusinessCertificate() {
      this.businessCertificateList.push({});
    },
    handleDeleteBusinessCertificate(index, e) {
      e.stopPropagation();
      this.businessCertificateList.splice(index, 1);
    },
    onBusinessItemChange(index) {
      return async (event, array) => {
        if (event.name) {
          const fileName = event.name;
          const fileNameArr = fileName.split('.');
          const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
          const extList = ['png', 'jpg', 'jpeg', 'bmp'];
          if (extList.indexOf(ext) === -1) { // 不支持格式， 处理兼容性问题
            ShowWarningMessage(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
            throw new Error(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
          }
        }
        this.dataLoading = true;
        try {
          const res = await uploadMaterialUseTemplate(event.raw);
          this.businessCertificateList[index].fileList = [{
            name: event.name,
            url: res,
          }];
        } catch (err) {
        }
        this.dataLoading = false;
      };
    },
    onBusinessItemRemove(index) {
      return async () => {
        this.businessCertificateList[index].fileList = [];
        this.$forceUpdate();
      };
    },
    // 董事信息
    handleAddShareholder() {
      this.shareholderList.push({});
    },
    handleDeleteShareholder(index) {
      this.shareholderList.splice(index, 1);
    },
    onShareholderItemChange(index, type) {
      return async (event, array) => {
        if (event.name) {
          const fileName = event.name;
          const fileNameArr = fileName.split('.');
          const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
          const extList = ['png', 'jpg', 'jpeg', 'bmp'];
          if (extList.indexOf(ext) === -1) { // 不支持格式， 处理兼容性问题
            ShowWarningMessage(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
            throw new Error(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
          }
        }
        this.dataLoading = true;
        try {
          const res = await uploadMaterialUseTemplate(event.raw);
          this.shareholderList[index][`${type}List`] = [{
            name: event.name,
            url: res,
          }];
        } catch (err) {
        }
        this.dataLoading = false;
      };
    },
    onShareholderItemRemove(index, type) {
      return async () => {
        this.shareholderList[index][`${type}List`] = [];
        this.$forceUpdate();
      };
    },
    // 受益人信息
    handleAddBeneficiary() {
      this.beneficiaryList.push({});
    },
    handleDeleteBeneficiary(index) {
      this.beneficiaryList.splice(index, 1);
    },
    onBeneficiaryItemChange(index, type) {
      return async (event, array) => {
        if (event.name) {
          const fileName = event.name;
          const fileNameArr = fileName.split('.');
          const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
          const extList = ['png', 'jpg', 'jpeg', 'bmp'];
          if (extList.indexOf(ext) === -1) { // 不支持格式， 处理兼容性问题
            ShowWarningMessage(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
            throw new Error(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
          }
        }
        this.dataLoading = true;
        try {
          const res = await uploadMaterialUseTemplate(event.raw);
          this.beneficiaryList[index][`${type}List`] = [{
            name: event.name,
            url: res,
          }];
        } catch (err) {
        }
        this.dataLoading = false;
      };
    },
    onBeneficiaryItemRemove(index, type) {
      return async () => {
        this.beneficiaryList[index][`${type}List`] = [];
        this.$forceUpdate();
      };
    },
    onViewExample(imageUrl) {
      this.exampleImgUrl = imageUrl;
      this.showExample = true;
    },
    async onBack() {
      try {
        await this.onTemporarySave();
      } catch (err) {
        //
      }
    },
    onPhoneInput(value) {
      const v = value.match(/^\d*(\d{0,10})/g)[0];
      this.basicInfo.phoneNumber = v;
    },
    async sendCaptcha() {
      if (this.captchaLeftTime > 0 || this.requestingCode) {
        return;
      }
      if (!this.basicInfo.phoneNumber) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.phone') }));
        return;
      }
      // if (this.basicInfo.areaCode === '+86') { // 中国大陆
      //   if (!(/^1\d{10}$/.test(this.basicInfo.phoneNumber))) {
      //     ShowWarningMessage(this.$t('message.validator.inputPhone'));
      //     return;
      //   }
      // } else if (this.basicInfo.areaCode === '+852') { // 中国香港
      //   if (!(/([5|6|9])\d{7}$/.test(this.basicInfo.phoneNumber))) {
      //     ShowWarningMessage(this.$t('message.validator.inputPhone'));
      //     return;
      //   }
      // }

      this.requestingCode = true;
      try {
        const lang = this.$store.getters.app.currentLan;
        const language = lang === 'zh-cn' ? 'zh' : lang;
        await getPhoneCaptcha({
          phoneNumber: this.basicInfo.phoneNumber.trim(),
          areaCode: this.basicInfo.areaCode,
          language,
        });
        if (this.timer) {
          clearInterval(this.timer);
        }

        this.captchaLeftTime = 59;
        this.timer = setInterval(() => {
          this.captchaLeftTime -= 1;
          if (this.captchaLeftTime <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } catch (err) {

      }
      this.requestingCode = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/element-variables.scss';

.account-supplement {
  ::v-deep .text-wrapper {
    width: 80%;
    min-width: 600px;
  }

  .back2mercahnt {
    font-weight: 600;
    font-size: 20px;
    color: $color-primary;
    line-height: 28px;
    cursor: pointer;
  }

  .drawer-form {
    width: 450px;

    .merchant-name-box {
      display: flex;
      align-items: center;
      height: 44px;
      background-color: $color-default;
      padding-left: 12px;
      padding-right: 12px;
      font-weight: 400;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 32px;

      .merchant-name {
        max-width: 400px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .el-icon-edit {
        font-weight: 800;
        cursor: pointer;
        color: $color-primary;
      }
    }

    ::v-deep .el-form-item__label {
      color: $color-text-primary;
      line-height: 32px;
      padding-bottom: 0px;
      font-weight: 800;
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    .supplement-info-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 32px;

      .link {
        color: $color-primary;
        cursor: pointer;
      }
    }

    .supplement-info-box {
      width: 100%;
      padding: 0 10px;
      padding-top: 5px;
      border-radius: 4px;
      border: 1px solid #B7B7B7;
      box-sizing: border-box;

      ::v-deep .supplement-upload {
        width: 100%;

        .el-upload {
          width: 100%;
        }

        .file-item {
          background-color: transparent;
          border-radius: 4px;
          border: 1px dashed $color-font-disabled;
          height: 36px;
          padding-left: 10px;
          margin-top: 2px;

          .thumbnail-box,
          .thumbnail-img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
      }

      .file-list-box {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
      }

      .bussiness-certificate-item,
      .shareholder-item,
      .beneficiary-item {
        margin-right: 10px;
        margin-bottom: 5px;

        &:last-child {
          margin-right: 0;
        }
      }

      .bussiness-certificate-item {
        .btn-delete {
          padding-left: 6px;
        }
      }
    }

    .btn-delete {
      color: $color-danger;
      font-weight: 800;
      font-size: 16px;
      cursor: pointer;
      padding: 0 10px;
    }

    .btn-add {
      display: inline-block;
      font-weight: 600;
      font-size: 14px;
      color: $color-primary;
      line-height: 32px;
      cursor: pointer;
    }

    .form-bottom-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 60px;
    }

    .btn-temporary-save {
      display: inline-block;
      font-weight: 600;
      font-size: 14px;
      color: $color-primary;
      line-height: 32px;
      cursor: pointer;
      margin-bottom: 10px;
    }

    .captcha-box {
      width: 100%;
      display: flex;
      align-content: center;

      .captcha-input {
        flex: 1;
        margin-right: 12px;
      }

      .btn-captcha {
        min-width: 120px;
        height: 44px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .fail-reason-box {
      position: relative;
      width: 450px;
      background: #FFF2F2;
      margin: 0 auto;
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 28px;
      padding-left: 10px;
      padding-right: 30px;
      padding-top: 1px;
      padding-bottom: 1px;
      box-sizing: border-box;
      white-space: pre-line;
    }
  }
}
</style>
